import createGenericContext from 'utils/createGenericContext';

import { CartItem } from 'models';
import { InventoryItem } from 'models/CartItem';

const [usePreviewPageContext, PreviewPageProvider] = createGenericContext<{
	inventoryItems: InventoryItem[];
	isInventoryLoaded: boolean;
	bookVariables: BookVariables;
	selectedStory: string;
	name1: string;
	name2: string;
	name3: string;
	character1: string;
	character2: string;
	character3: string;
	city: string;
	dedication1: string;
	dedication2: string;
	dedication3: string;
	dedication4: string;
	productsChecked: (TreePrimaryItemID | TreeSecondaryItemID)[];
	setSelectedStory: React.Dispatch<React.SetStateAction<string>>;
	setName1: React.Dispatch<React.SetStateAction<string>>;
	setName2: React.Dispatch<React.SetStateAction<string>>;
	setName3: React.Dispatch<React.SetStateAction<string>>;
	setCharacter1: React.Dispatch<React.SetStateAction<string>>;
	setCharacter2: React.Dispatch<React.SetStateAction<string>>;
	setCharacter3: React.Dispatch<React.SetStateAction<string>>;
	setCity: React.Dispatch<React.SetStateAction<string>>;
	setDedication1: React.Dispatch<React.SetStateAction<string>>;
	setDedication2: React.Dispatch<React.SetStateAction<string>>;
	setDedication3: React.Dispatch<React.SetStateAction<string>>;
	setDedication4: React.Dispatch<React.SetStateAction<string>>;
	setProductsChecked: React.Dispatch<React.SetStateAction<(TreePrimaryItemID | TreeSecondaryItemID)[]>>;
	cartItems: CartItem[];
	setCartItems: React.Dispatch<React.SetStateAction<CartItem[]>>;
	formattedCartTotal: string;
	isAdmin: boolean;
	handleContinue: () => void;
	handleBack: () => void;
}>();

export { usePreviewPageContext, PreviewPageProvider };
